import React from 'react';
import { Quote } from 'lucide-react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const TestimonialCard = ({ testimonial, index }) => {
  const [cardRef, cardVisible] = useScrollAnimation();
  
  return (
    <div 
      ref={cardRef}
      className={`testimonial-card network-card animate-scale animate-delay-${Math.min(index + 1, 4)} ${cardVisible ? 'is-visible' : ''}`}
    >
      <div className="quote-icon">
        <Quote size={32} />
      </div>
      <p className="testimonial-quote body-medium">
        "{testimonial.quote}"
      </p>
      <div className="testimonial-author">
        <div className="author-image">
          <img src={testimonial.image} alt={testimonial.author} />
        </div>
        <div className="author-info">
          <p className="author-name">{testimonial.author}</p>
          <p className="author-role">{testimonial.role}</p>
        </div>
      </div>
    </div>
  );
};

export const Testimonials = () => {
  const [titleRef, titleVisible] = useScrollAnimation();

  const testimonials = [
    {
      quote: "Your commitment to nurturing young leaders is evident. I am grateful for the time, effort, and passion you dedicate to helping youth grow. Thank you for making such a positive difference in their lives.",
      author: "John M.",
      role: "Community Leader",
      image: "https://customer-assets.emergentagent.com/job_heath-wellbeing/artifacts/dmb2eonu_John%20M%20Circle.png"
    },
    {
      quote: "I keep going back to that wisdom bomb. You're delivering the answers to the questions we don't always know we have. Love you for what you are doing.",
      author: "Beverly A.",
      role: "Workshop Participant",
      image: "https://customer-assets.emergentagent.com/job_heath-wellbeing/artifacts/0pke476f_Beverly%20A%20Circle.png"
    },
    {
      quote: "You're exactly right. Everything you have said is really true. Dealing with PTSD and childhood trauma, your guidance has been profound. It would be an honor to work with you.",
      author: "Simon G.",
      role: "Personal Development Client",
      image: "https://customer-assets.emergentagent.com/job_heath-wellbeing/artifacts/h7n3gzld_Simon%20G%20circle.png"
    }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 
            ref={titleRef}
            className={`display-medium animate-slide-up ${titleVisible ? 'is-visible' : ''}`}
          >
            Transformation Stories
          </h2>
          <p className="body-large section-subtitle">
            Real people. Real results. Real transformation.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
